import React, { useState, useEffect } from 'react';
import API from '../library/ApiManager'
import Fnc from '../library/Functions'
import Loader from "react-loader-spinner";

function CfInp(props) {

  const [loading, setLoading] = useState(null);
  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [cfVerified, setCfVerified] = useState(false);

  //const [, updateState] = React.useState();
  //const forceUpdate = React.useCallback(() => updateState({}), []);

  useEffect(() => {
    // Similar to componentDidMount and componentDidUpdate:
    if (props.isLogged && props.cf != null && props.cf.length > 0 && props.loadData) {
      //ho un CF valido e sono loggato. Devo caricare i contenuti del customer da Salesforce, non prendo quelli di SSO. 
      // Una volta caricati verranno rimandati con una callback al modulo fatturazione che provvederà ad aggiornare tutti gli altri campi.
      Fnc.log("=== CUSTOMER CALL", props, Fnc.LogLvl.INFO);
      checkCf(props.cf);
    }

  }, [props.isLogged, props.cf, props.loadData]); //empty array => chiama solo una volta. Senza la chiama ad ogni cambiamento

  function onBlur(e) {
    let val = e.target.value;
    checkCf(val);
  }

  function checkCf(val) {

    //if (props.required) {
    //è un campo obbligatorio?

    if (val && val.length > 0) {
      //non ho un valore vuoto

      if (cfVerified !== val) {
        //non è un valore che ho già controllato

        setCfVerified(null); //resetto eventuali salvataggi precedenti

        let valdCf = Fnc.validateCf(val);
        if (valdCf === Fnc.EnmCf.OK) {
          //piva formalmente valida?

          setLoading(true);

          //-----
          API.getCustomer(val, (data) => {
            if (data && data != null) {
              setCfVerified(val);
              if (props.isLogged) {
                //UTENTE LOGGATO : controllo che il codice della response sia OK
                if (data && data.response && (data.response.code === 'OK')) {
                  setShowError(false);
                  setErrorMsg(null);
                  props.callback(new Fnc.Ret(Fnc.EnmCf.OK, data));
                } else {
                  setShowError(true);
                  setErrorMsg(Fnc.EnmCf.KO.msg);
                  props.callback(new Fnc.Ret(Fnc.EnmCf.KO));
                }
              } else {
                //UTENTE NON LOGGATO : controllo tutte le condizioni
                if (data && data.response && data.response.code === 'OK') {
                  if (data.invoicingData && (data.invoicingData.alreadyKnown || data.invoicingData.commission)) {
                    //cf di un già cliente
                    setShowError(true);
                    setErrorMsg(Fnc.EnmCf.NOTFREE.msg);
                    props.callback(new Fnc.Ret(Fnc.EnmCf.NOTFREE));
                  } else {
                    setShowError(false);
                    setErrorMsg(null);
                    props.callback(new Fnc.Ret(Fnc.EnmCf.OK, data));
                  }
                } else if (data && data.response && data.response.code === 'NOT_FOUND') {
                  //cf valido ma non trovato nei database SALESFORCE. N.B. Passo il cf invece che tutto l'oggetto customer
                  setShowError(false);
                  setErrorMsg(null);
                  props.callback(new Fnc.Ret(Fnc.EnmCf.NOT_FOUND, val));
                } else {
                  setShowError(true);
                  setErrorMsg(Fnc.EnmCf.KO.msg);
                  props.callback(new Fnc.Ret(Fnc.EnmCf.KO));
                }
              }
            } else {
              //CHIMATA KO : qualcosa è andato storto nella chiamata rest
              setCfVerified(null);
              setShowError(true);
              setErrorMsg(Fnc.EnmCf.SERVER_DOWN.msg);
              props.callback(new Fnc.Ret(Fnc.EnmCf.SERVER_DOWN));
            }
            setLoading(false);

          });

        } else {
          //la cf specificata è formalmente non valida
          setCfVerified(null);
          setShowError(true);
          setErrorMsg(valdCf.msg);
          props.callback(new Fnc.Ret(valdCf));
        }

      }

    } else {
      if (props.required) {
        setShowError(true);
        setErrorMsg(Fnc.EnmCf.EMPTY.msg);
        props.callback(new Fnc.Ret(Fnc.EnmCf.EMPTY));
        setCfVerified(null); //resetto eventuali salvataggi precedenti
      }
    }

    //} else {
    //  setShowError(false);
    //  setErrorMsg(null);
    //  props.callback(new Fnc.Ret(Fnc.EnmCf.OK, null));
    //}

  }


  return (
    <>
      <input className={`form-control ${props.isLogged && "disabled"} `} type="text" placeholder="c " disabled={props.isLogged} aria-labelledby="piva" key={props.cf} defaultValue={props.cf} onBlur={onBlur}></input>
      <span className={`placeholder-text ${showError && "lblError"} `}>{(props.required ? "* " : "") + "Codice Fiscale"}<Loader visible={loading} className="loadingSpinner" type={Fnc.LoadingInp.TYPE} color={Fnc.LoadingInp.COLOR} height={Fnc.LoadingInp.HEIGHT} width={Fnc.LoadingInp.WIDTH} timeout={Fnc.LoadingInp.TIMEOUT} /></span>
      {showError && <div className="iol-error-label">{errorMsg}</div>}
    </>
  );
}

export default CfInp;
